import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    excluir(parcelamento) {
        return axiosJwt.delete(`${api}/contratos/${parcelamento.idContrato}/investimentos-previstos/${parcelamento.idInvestimentoPrevistoContrato}/parcelas/${parcelamento.idParcela}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserir(parcelamento, idContrato, idInvestimento) {
        return axiosJwt.post(`${api}/contratos/${idContrato}/investimentos-previstos/${idInvestimento}/parcelas`, parcelamento)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizar(parcelamento, idContrato, idInvestimento, idParcelaInvestimentoPrevistoContrato) {
        return axiosJwt.put(`${api}/contratos/${idContrato}/investimentos-previstos/${idInvestimento}/parcelas/${idParcelaInvestimentoPrevistoContrato}`, parcelamento)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterParcelamentos(parcelamento) {
        return axiosJwt.get(`${api}/contratos/${parcelamento.idContrato}/investimentos-previstos/${parcelamento.idInvestimento}/parcelas/`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterParcelamento(parcelamento) {
        return axiosJwt.get(`${api}/contratos/${parcelamento.idContrato}/investimentos-previstos/${parcelamento.idInvestimento}/parcelas/${parcelamento.idParcelaInvestimentoPrevistoContrato}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    download(anexo) {
        return axiosJwt
            .get(`${api}/contratos/${anexo.idContrato}/investimentos-previstos/${anexo.idInvestimento}/parcelas/${anexo.idParcela}/documentos/${anexo.idDocumento}/download`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(anexo) {
        console.log("o que chhega, ", anexo)
        return axiosJwt.delete(`${api}/contratos/${anexo.idContrato}/investimentos-previstos/${anexo.idInvestimentoPrevistoContrato}/parcelas/${anexo.idParcela}/documentos/${anexo.idDocumento}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirAnexo(anexo) {
        const formData = new FormData()
        formData.append('descricao', anexo.descricao)
        formData.append('documento', anexo.documento)
        
        return axiosJwt
            .post(`${api}/contratos/${anexo.idContrato}/investimentos-previstos/${anexo.idInvestimentoPrevistoContrato}/parcelas/${anexo.idParcela}/documentos`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexos(anexo) {
        return axiosJwt.get(`${api}/contratos/${anexo.idContrato}/investimentos-previstos/${anexo.idInvestimentoPrevistoContrato}/parcelas/${anexo.idParcela}/documentos`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },
}
